import { useMutation, useQuery } from "react-query";
import { mixpanel } from "../../mixpanel";
import { API } from "../../utils/AxiosInstance";

interface LoginURLResponse {
    url: string;
}

const LOGIN_URL_GENERATOR_URLS: { [k: string]: string } = {
    ohio: "/sessions/ohio-university",
    mercy: "/sessions/mercy",
};

export const useLoginURL = (source: string) =>
    useQuery(["login-urls", source], () =>
        API.post<LoginURLResponse>(LOGIN_URL_GENERATOR_URLS[source])
            .then((resp) => resp.data)
            .then((data) => data.url)
    );

export interface SessionParams {
    email: string;
    password: string;
    clientId: string | null;
}

interface SessionResponse {
    success: boolean;
    name: string;
    email: string;
    token: string;
    user_id: string;
}

export const useLoginMutation = () =>
    useMutation(({ email, password, clientId }: SessionParams) =>
        API.post<SessionResponse>("/sessions", {
            email,
            password,
            client_id: clientId,
        })
            .then(({ data }) => data)
            .then(({ token, ...rest }) => {
                localStorage.setItem("token", token);
                return { token, ...rest };
            })
            .catch((error) => {
                const {
                    data: { message },
                } = error;

                return Promise.reject(new Error(message));
            })
    );

export const useLogoutMutation = () =>
    useMutation(() =>
        API.delete("/sessions")
            .then(() => {
                localStorage.removeItem("token");
                mixpanel.reset();
            })
            // eslint-disable-next-line no-return-assign
            .then(() => (window.location.href = "/"))
    );
